module.exports = __webpack_public_path__ + "assets/img/contact.f95a153f.jpg";